import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
import Notification from "../components/common/Notification";
import { FaEdit, FaTrash, FaPlus } from "react-icons/fa";
import styles from "./AdminPage.module.css";

function AdminMenuPage() {
  const [filter, setFilter] = useState("All Categories");
  const [menuItems, setMenuItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [notification, setNotification] = useState(null);

  const showToast = (message, type = "success") => {
    setNotification({ message, type });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const catRes = await fetch("/api/categories?type=Menu");
        const catData = await catRes.json();
        setCategories(catData);

        const prodRes = await fetch("/api/cms/products");
        const prodData = await prodRes.json();

        const menuOnly = prodData.filter(
          (item) => item.category && item.category.type === "Menu"
        );

        setMenuItems(menuOnly);
      } catch (error) {
        showToast("Error fetching menu.", "error");
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleDelete = async (id, name) => {
    if (window.confirm(`Delete "${name}"?`)) {
      const adminKey = localStorage.getItem("adminKey");
      try {
        const res = await fetch(`/api/cms/products/${id}`, {
          method: "DELETE",
          headers: {
            "x-admin-key": adminKey,
          },
        });
        if (res.ok) {
          setMenuItems((prev) => prev.filter((item) => item._id !== id));
          showToast(`Deleted "${name}" successfully.`, "danger");
        } else {
          showToast("Delete failed.", "error");
        }
      } catch (error) {
        showToast("Network error.", "error");
      }
    }
  };

  // --- UPDATED HELPER: Supports both Numbers and Strings like "120/240" ---
  const formatPriceInfo = (item) => {
    if (
      item.sizePrices &&
      (item.sizePrices.regular > 0 || item.sizePrices.hbs > 0)
    ) {
      let prices = [];
      if (item.sizePrices.regular > 0)
        prices.push(`R: ${item.sizePrices.regular}`);
      if (item.sizePrices.hbs > 0) prices.push(`H: ${item.sizePrices.hbs}`);
      if (item.sizePrices.large > 0) prices.push(`L: ${item.sizePrices.large}`);
      return prices.join(", ");
    }

    // UPDATED: Check if price exists and is not zero (as number or string)
    if (item.price && item.price !== 0 && String(item.price).trim() !== "") {
      return `${item.price} ETB`;
    }
    return "";
  };

  const displayedItems =
    filter === "All Categories"
      ? menuItems
      : menuItems.filter((item) => item.category?.name === filter);

  return (
    <div className={styles.adminPage}>
      <Navbar />
      {notification && (
        <Notification
          message={notification.message}
          type={notification.type}
          onClose={() => setNotification(null)}
        />
      )}
      <div className={styles.adminHero}>
        <h1>Manage Menu</h1>
        <Link
          to="/admin/menu/new"
          className={`${styles.adminBtn} ${styles.primary}`}
        >
          <FaPlus /> Add New Item
        </Link>
      </div>
      <div className={styles.adminContentContainer}>
        <div
          className={styles.formGroup}
          style={{ maxWidth: "300px", marginBottom: "20px" }}
        >
          <label htmlFor="categoryFilter">Filter by Category</label>
          <select
            id="categoryFilter"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          >
            <option value="All Categories">All Categories</option>
            {categories.map((cat) => (
              <option key={cat._id} value={cat.name}>
                {cat.name}
              </option>
            ))}
          </select>
        </div>
        <div className={styles.adminTableContainer}>
          <table className={styles.adminTable}>
            <thead>
              <tr>
                <th>Image</th>
                <th>Name</th>
                <th>Category</th>
                <th>Price / Info</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan="5" style={{ textAlign: "center" }}>
                    Loading...
                  </td>
                </tr>
              ) : displayedItems.length === 0 ? (
                <tr>
                  <td colSpan="5" style={{ textAlign: "center" }}>
                    No menu items found.
                  </td>
                </tr>
              ) : (
                displayedItems.map((item) => (
                  <tr key={item._id}>
                    <td>
                      {item.imageURL ? (
                        <img
                          src={`${item.imageURL}`}
                          alt={item.name}
                          className={styles.tableImg}
                        />
                      ) : (
                        <div
                          className={styles.tableImg}
                          style={{ background: "#111" }}
                        ></div>
                      )}
                    </td>
                    <td>{item.name}</td>
                    <td>{item.category?.name || "Uncategorized"}</td>
                    <td className={styles.tablePrice}>
                      {formatPriceInfo(item)}
                    </td>
                    <td className={styles.tableActions}>
                      <Link
                        to={`/admin/menu/edit/${item._id}`}
                        className={`${styles.adminBtn} ${styles.iconBtn}`}
                      >
                        <FaEdit />
                      </Link>
                      <button
                        className={`${styles.adminBtn} ${styles.iconBtn} ${styles.danger}`}
                        onClick={() => handleDelete(item._id, item.name)}
                      >
                        <FaTrash />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <Link to="/admin/dashboard" className={styles.adminBackLink}>
          &larr; Back to Dashboard
        </Link>
      </div>
      <Footer />
    </div>
  );
}

export default AdminMenuPage;
